import { CONCILIATION_ES_ES } from "#pages/backoffice/conciliation/translations/conciliation-es-es";
import eventConference from "./event-conference.json";
import customerAndSupplier from "./customer-and-supplier.json";
import accountsPayableReceivable from "./accounts-payable-receivable.json";
import bills from "./bills.json";
import finExManagerialReport from "./finex-managerial-report.json";
import planOfAccounts from "./plan-of-accounts.json";
import stockTransferHistory from "./stock-transfer-history.json";

export const backofficeEsES = {
	conciliation: CONCILIATION_ES_ES,
	customerAndSupplier,
	eventConference,
	accountsPayableReceivable,
	bills,
	finExManagerialReport,
	planOfAccounts,
	stockTransferHistory,
};
